import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RenderContextComponent } from '../../../../../../../../../models/base/render-context-component';

@Component({
  selector: 'app-glass-house-header-quantity-and-price',
  templateUrl: './glass-house-header-quantity-and-price.component.html',
  styleUrl: './glass-house-header-quantity-and-price.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouseHeaderQuantityAndPriceComponent extends RenderContextComponent {
  setupViews() {}
  setupBindings() {}
}
